export default function WebProjects({ sectionRef, isDark }) {
	return (
		<section ref={sectionRef} className='slide flex-col py-8'>
			<div className='pb-6'>
				<h3>Web Development</h3>
				<p className='pb-3'>
					Explore a few of my web creations that bring fun and functionality
					together.
				</p>
				<hr className='separator' />
			</div>
			<div className='web-project-container'>
				<WebProject
					isDark={isDark}
					name={'Sudoku'}
					url={'https://sudoku-rv.web.app/'}
					img={'sudoku.png'}
					desc={
						'Experience my unique interpretation of the timeless puzzle phenomenon, bringing you the ultimate blend of strategy and entertainment.'
					}
				/>
				<WebProject
					isDark={isDark}
					name={'Minesweeper'}
					url={'https://zensweeper.web.app/'}
					img={'zensweeper.png'}
					desc={
						'Immerse yourself in a relaxing and addictive game of minesweeper, where tranquility meets the challenge of uncovering hidden treasures.'
					}
				/>
				<WebProject
					isDark={isDark}
					name={'What State is This?'}
					url={'https://what-state-rv.web.app/'}
					img={'what-state.png'}
					desc={
						'Embark on a captivating journey to test your knowledge of all 50 states, and discover the thrill of geography like never before.'
					}
				/>
			</div>
		</section>
	)
}

function WebProject({ name, url, img, desc, isDark }) {
	return (
		<a href={url} target='_blank' rel='noreferrer noopener'>
			<div
				style={{
					backgroundImage: `linear-gradient(to bottom, rgba(${
						!isDark ? '67, 73, 58, 0' : '162, 176, 141, 0.2'
					}), rgba(${
						!isDark ? '67, 73, 58' : '162, 176, 141'
					}, 1)),url(/assets/imgs/web-development/${img})`,
					transition: 'background-size 0.4s ease-in-out',
				}}
				className='webproject'
			>
				<div className='p-3 lg:p-4'>
					<h4>{name}</h4>
					<p>{desc}</p>
				</div>
			</div>
		</a>
	)
}
